import { useEffect, useState } from 'react';

import config from '../config/config';
import axios from "axios"; // Import Axios for API requests
import {  
  Users, 
  BookOpen, 
  DollarSign, 
  Calendar, 
  AlertCircle,
  CreditCard,
  FileText,
  ChevronRight,
  MoreVertical,
  Download,
  ArrowUpRight,
  ArrowDownRight,
  Book
} from 'lucide-react';
import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, LineChart, Line, Tooltip } from 'recharts';

// Sample data for charts
const budgetDatas = [
  { name: 'Faculty', value: 45 },
  { name: 'Facilities', value: 20 },
  { name: 'Technology', value: 15 },
  { name: 'Admin', value: 10 },
  { name: 'Activities', value: 10 },
];

const COLORS = ['#4F46E5', '#818CF8', '#60A5FA', '#34D399', '#F472B6'];

const revenueDataz = [
  { month: 'Jan', amount: 42000 },
  { month: 'Feb', amount: 45000 },
  { month: 'Mar', amount: 46000 },
  { month: 'Apr', amount: 48000 },
  { month: 'May', amount: 52000 },
  { month: 'Jun', amount: 58000 },
];

const expensesByDepartments = [
  { department: 'Science', amount: 28000 },
  { department: 'Math', amount: 24000 },
  { department: 'English', amount: 22000 },
  { department: 'Arts', amount: 18000 },
  { department: 'Sports', amount: 16000 },
];

export default function SchoolFinanceDashboard() {
  const [selectedPeriod, setSelectedPeriod] = useState('monthly');
  const [count, setCount] = useState(null);
  const [balance, setBalance] = useState(null);
  const [amountPaid, setFeePaid] = useState(null);
  const [grants, setCapitationGrant] = useState(null);
   const [budgetData, setFeeByClass] = useState([]);
   const [expensesByDepartment, setSalaryByDepartment] = useState([]);
   const[recentTransactions,setrecentInvoices]=useState([]);
   const[upcomingPayments,setrecentPayments]=useState([]);

 const[revenueData,setrevenueData]=useState([]);  const token = localStorage.getItem("token");
  

  const params = {
  start_date: '2024-01-01',
  end_date: '2030-12-31'
};

  useEffect(() => {
    //get students count
   axios.get(config.API_URL+'/api/studentsCount', {
  headers: {
    Authorization: `Bearer ${token}`
  }
 
})
.then(response => {
  setCount(response.data.count);
})
.catch(error => {
  console.error('Error fetching student count:', error);
});

    //get fee balances
axios.get(config.API_URL+'/api/feeBalance', {
  headers: {
    Authorization: `Bearer ${token}`
  },
   params:params
})
.then(response => {
   setBalance(response.data.balance);
})
.catch(error => {
   console.error('Error fetching fee balance:', error);
});


     
 //get fee balances
axios.get(config.API_URL+'/api/feePaid', {
  headers: {
    Authorization: `Bearer ${token}`
  },
   params:params
})
.then(response => {
    setFeePaid(response.data.amountPaid);
})
.catch(error => {
   console.error('Error fetching fee paid:', error);
});


     
 //get fee balances
axios.get(config.API_URL+'/api/dashboardData', {
  headers: {
    Authorization: `Bearer ${token}`
  },
   params:params
})
.then(response => {
    setFeeByClass(response.data.feesByClass);
     setSalaryByDepartment(response.data.salariesByDepartment);
     setrecentInvoices(response.data.recentInvoices);
     setrecentPayments(response.data.recentPayments);
     setrevenueData(response.data.revenueData);
})
.catch(error => {
   console.error('Error fetching dashboardData:', error);
});

axios.get(config.API_URL+'/api/capitationGrants', {
  headers: {
    Authorization: `Bearer ${token}`
  },
   params:params
})
.then(response => {
     setCapitationGrant(response.data.grants);
})
.catch(error => {
   console.error('Error fetching capitationGrants:', error);
});

  }, []);

  
  const recentTransactionz = [
    { id: 1, name: 'Science Lab Equipment', amount: -5240, date: 'May 14, 2025', status: 'completed', department: 'Science' },
    { id: 2, name: 'Student Tuition Payment', amount: 1200, date: 'May 13, 2025', status: 'completed', department: 'Finance' },
    { id: 3, name: 'Library Books', amount: -2100, date: 'May 11, 2025', status: 'pending', department: 'Library' },
    { id: 4, name: 'Cafeteria Supplies', amount: -1850, date: 'May 10, 2025', status: 'completed', department: 'Operations' },
  ];

  const upcomingPaymentz = [
    { id: 1, name: 'Teacher Payroll', amount: 28600, date: 'May 25, 2025', priority: 'high' },
    { id: 2, name: 'Building Maintenance', amount: 4200, date: 'May 30, 2025', priority: 'medium' },
    { id: 3, name: 'Software Licenses', amount: 1800, date: 'June 5, 2025', priority: 'low' },
  ];
  
  return (
    <div className="bg-gray-50 p-6">
      {/* Dashboard Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">School Finance Dashboard</h1>
        <p className="text-gray-500">Financial overview</p>
      </div>
      
      {/* Quick Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div className="flex justify-between items-start mb-4">
            <div className="bg-indigo-100 p-3 rounded-lg">
              <CreditCard size={24} className="text-blue-600" />
            </div>
            <span className="text-xs font-medium text-green-500 bg-green-50 px-2 py-1 rounded-full flex items-center">
              Total
            </span>
          </div>
          <h3 className="text-gray-500 text-sm mb-1">Fee Balance</h3>
          <p className="text-2xl font-bold text-gray-800">{balance !== null ? balance : 'Loading...'}</p>
          
        </div>
        
        <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div className="flex justify-between items-start mb-4">
            <div className="bg-blue-100 p-3 rounded-lg">
              <CreditCard size={24} className="text-blue-600" />
            </div>
            <span className="text-xs font-medium text-green-500 bg-green-50 px-2 py-1 rounded-full flex items-center">
              Total
            </span>
          </div>
          <h3 className="text-gray-500 text-sm mb-1">Fee Paid</h3>
          <p className="text-2xl font-bold text-gray-800">{amountPaid !== null ? amountPaid : 'Loading...'}</p>
         
        </div>
        
        <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div className="flex justify-between items-start mb-4">
            <div className="bg-emerald-100 p-3 rounded-lg">
              <Users size={24} className="text-emerald-600" />
            </div>
            <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
              Total
            </span>
          </div>
          <h3 className="text-gray-500 text-sm mb-1">Student Enrollment</h3>
          <p className="text-2xl font-bold text-gray-800">{count !== null ? count : 'Loading...'}</p>
         
        </div>
        
        <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <div className="flex justify-between items-start mb-4">
            <div className="bg-amber-100 p-3 rounded-lg">
              <BookOpen size={24} className="text-amber-600" />
            </div>
            <span className="text-xs font-medium text-green-500 bg-green-50 px-2 py-1 rounded-full flex items-center">
              Total
            </span>
          </div>
          <h3 className="text-gray-500 text-sm mb-1">Employees</h3>
          <p className="text-2xl font-bold text-gray-800">{grants !== null ? grants : 'Loading...'}</p>
          
        </div>
      </div>
      
      {/* Middle Section - Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        {/* Budget Allocation Chart */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="flex justify-between items-center mb-6">
            <h3 className="font-bold text-gray-800">Fee Balance By Class</h3>
            
          </div>
          
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={budgetData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={80}
                  paddingAngle={2}
                  dataKey="value"
                  label={({ name, percent }) => `${name}`}
                  labelLine={false}
                >
                  {budgetData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>


          
          <div className="grid grid-cols-2 gap-2 mt-4">
            {budgetData.map((item, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: COLORS[index % COLORS.length] }}></div>
                <span className="text-xs text-gray-600">{item.name}: {item.value}</span>
              </div>
            ))}
          </div>


        </div>

                {/* Department Expenses */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="flex justify-between items-center mb-6">
            <h3 className="font-bold text-gray-800">Salaries By Department</h3>
            <button className="text-gray-400 hover:text-gray-600">
              <MoreVertical size={18} />
            </button>
          </div>
          
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={expensesByDepartment} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="#f0f0f0" />
                <XAxis 
                  type="number" 
                  axisLine={false} 
                  tickLine={false}
                  tickFormatter={(value) => `${value/1000}k`}
                />
                <YAxis 
                  type="category" 
                  dataKey="department" 
                  axisLine={false} 
                  tickLine={false} 
                />
                <Tooltip 
                  formatter={(value) => [`${value.toLocaleString()}`, 'Expense']}
                />
                <Bar 
                  dataKey="amount" 
                  fill="#818CF8" 
                  radius={[0, 4, 4, 0]} 
                  barSize={16}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
        
        {/* Revenue Trend */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="flex justify-between items-center mb-6">
            <h3 className="font-bold text-gray-800">Fee Payment Trend</h3>
            <button className="text-gray-400 hover:text-gray-600">
              <Download size={18} />
            </button>
          </div>
          
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={revenueData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} />
                <YAxis 
                  axisLine={false} 
                  tickLine={false} 
                  tickFormatter={(value) => `${value/1000}k`}
                />
                <Tooltip 
                  formatter={(value) => [`${value.toLocaleString()}`, 'Revenue']}
                  labelFormatter={(label) => `${label} 2025`}
                />
                <Line 
                  type="monotone" 
                  dataKey="amount" 
                  stroke="#4F46E5" 
                  strokeWidth={3}
                  dot={{ strokeWidth: 0, r: 0 }}
                  activeDot={{ r: 6, strokeWidth: 0 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        
          {/* Bottom Section - Transactions & Calendar */}
      <div className="grid grid-cols-1 lg:grid-cols- gap-6">

      </div>
      
      {/* Bottom Section - Transactions & Calendar */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-5">
        {/* Recent Transactions */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="flex justify-between items-center mb-6">
            <h3 className="font-bold text-gray-800">{recentTransactions.length} Recent Invoices</h3>
            <a href="/invoices" className="text-indigo-600 text-sm font-medium flex items-center hover:text-indigo-700">
              View All <ChevronRight size={16} />
            </a>
          </div>
          
          <div className="overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead>
                  <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <th className="px-2 py-3">Transaction</th>
                    <th className="px-2 py-3">Amount</th>
                    <th className="px-2 py-3">Date</th>
                    <th className="px-2 py-3">Status</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {recentTransactions.map((transaction) => (
                    <tr key={transaction.id} className="text-sm">
                      <td className="px-2 py-4">
                        <div className="flex items-center">
                          <div className={`
                            p-2 rounded-lg mr-3
                            ${transaction.amount > 0 ? 'bg-green-100' : 'bg-blue-100'}
                          `}>
                            {transaction.amount > 0 ? (
                              <FileText size={16} className="text-green-600" />
                            ) : (
                              <FileText size={16} className="text-blue-600" />
                            )}
                          </div>
                          <div>
                            <p className="font-medium text-gray-800">{transaction.name}</p>
                            <p className="text-xs text-gray-500">{transaction.department}</p>
                          </div>
                        </div>
                      </td>
                      <td className={`px-2 py-4 font-medium ${
                        transaction.amount > 0 ? 'text-green-600' : 'text-gray-800'
                      }`}>
                        {transaction.amount > 0 ? '+' : ''}{Math.abs(transaction.amount).toLocaleString()}
                      </td>
                      <td className="px-2 py-4 text-gray-500">{transaction.date}</td>
                      <td className="px-2 py-4">
                        <span className={`px-2 py-1 text-xs rounded-full ${
                          transaction.status === 'completed' 
                            ? 'bg-green-50 text-green-600' 
                            : 'bg-amber-50 text-amber-600'
                        }`}>
                          {transaction.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        
        {/* Upcoming Payments */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
          <div className="flex justify-between items-center mb-6">
            <h3 className="font-bold text-gray-800"> {upcomingPayments.length} Recent Payments</h3>
            <a href="/payments" className="text-indigo-600 text-sm font-medium flex items-center hover:text-indigo-700">
              View Payments <ChevronRight size={16} className="ml-1" />
            </a>
          </div>
          
          <div className="space-y-4">
            {upcomingPayments.map((payment) => (
              <div key={payment.id} className="flex items-center p-4 border border-gray-100 rounded-lg">
                <div className={`
                  h-10 w-10 rounded-lg flex items-center justify-center mr-4
                  ${payment.priority === 'high' ? 'bg-red-100' : payment.priority === 'medium' ? 'bg-amber-100' : 'bg-blue-100'}
                `}>
                  {payment.priority === 'high' ? (
                    <AlertCircle size={20} className="text-red-600" />
                  ) : payment.priority === 'medium' ? (
                    <Calendar size={20} className="text-amber-600" />
                  ) : (
                    <Book size={20} className="text-blue-600" />
                  )}
                </div>
                <div className="flex-grow">
                  <div className="flex justify-between">
                    <p className="font-medium text-gray-800">{payment.name}</p>
                    <p className="font-bold text-gray-800">{payment.amount.toLocaleString()}</p>
                  </div>
                  <div className="flex justify-between mt-1">
                    <p className="text-xs text-gray-500">Due on {payment.date}</p>
                    
                  </div>
                </div>
              </div>
            ))}
          </div>
          
        
        </div>
      </div>
    </div>
  );
}